import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "md:min-h-[calc(100svh-143px-192px)] min-h-[calc(100svh-311px-128px)] content-center" }

import AppBanner, { IAppBannerProps } from '@/components/AppBanner/AppBanner.vue';
import FormStepInputs from '@/components/FormStepInputs/FormStepInputs.vue';
import { ISitecoreFormGenericInput } from '@/interfaces';
import { computed, ComputedRef, onMounted, ref } from 'vue';
import { UnsubscribeService as _unsubscribe } from '@/services/store';
import { RichText } from '@sitecore-jss/sitecore-jss-vue';
import { useAnalyticsStore } from '@/store';
import { FormEvents } from '@/enums/form-events.enum';


export default /*@__PURE__*/_defineComponent({
  __name: 'Unsubscribe',
  props: {
    content: {},
    id: {},
    name: {}
  },
  setup(__props: any) {

const analyticsStore = useAnalyticsStore();
const props = __props;
const loading = ref(true);
const failed = ref(false);
const queries = location.search?.toLowerCase();
const type = ref<string>(new URLSearchParams(queries).get('type') ?? '');
const emailSubscription = ref<string>(new URLSearchParams(queries).get('emailsubscription') ?? '');
const customer = ref<string>(new URLSearchParams(queries).get('customer') ?? '');
const test = ref<string>(new URLSearchParams(queries).get('test') ?? '');

const appBanner = props.content.find((item) => item.formInputId.value == 'appBanner');
const unsubscribeFailed = props.content.find((item) => item.formInputId.value == 'unsubscribeFailed');
const unsubscribeSucceed = props.content.find((item) => item.formInputId.value == 'unsubscribeSucceed');
const appBannerBindings: ComputedRef<IAppBannerProps> = computed(() => ({
  title: appBanner?.title?.value,
  subTitle: appBanner?.subTitle?.value,
  classes: appBanner?.innerClass?.value,
  appleDownloadLink: appBanner?.appleDownloadLink?.value,
  googleDownloadLink: appBanner?.googleDownloadLink?.value,
  showAppStoreButtons: appBanner?.showAppStoreButtons?.value,
  greyBg: appBanner?.greyBg?.value,
}));

onMounted(async () => {
  if (!test.value) {
    try {
      await _unsubscribe.unsubscribe(customer.value, type.value, emailSubscription.value);
      // Push analytics
      analyticsStore.pushAnalytics({
        event: FormEvents.COMPLETE,
        form: {
          name: 'Unsubscribe',
          productName: type.value,
        },
      });
    } catch (error) {
      failed.value = true;
      // Push analytics
      analyticsStore.pushAnalytics({
        event: FormEvents.JEOPARDY,
        form: {
          name: 'Unsubscribe',
          formErrorDetail: error as string,
          formErrorType: 'Unsubscribe failed',
        },
      });
    } finally {
      loading.value = false;
    }
  } else {
    loading.value = false;
    failed.value = test.value != '1';
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(FormStepInputs, {
      step: {
        stepName: _ctx.name,
        formInputs: _ctx.content,
      }
    }, {
      unsubscribeFailed: _withCtx(() => [
        _createElementVNode("div", null, [
          (_unref(unsubscribeFailed) && failed.value)
            ? (_openBlock(), _createBlock(_unref(RichText), {
                key: 0,
                field: _unref(unsubscribeFailed).label,
                class: _normalizeClass(_unref(unsubscribeFailed).outerClass?.value)
              }, null, 8, ["field", "class"]))
            : _createCommentVNode("", true)
        ])
      ]),
      unsubscribeSucceed: _withCtx(() => [
        _createElementVNode("div", null, [
          (_unref(unsubscribeSucceed) && !failed.value)
            ? (_openBlock(), _createBlock(_unref(RichText), {
                key: 0,
                field: _unref(unsubscribeSucceed).label,
                class: _normalizeClass(_unref(unsubscribeSucceed).outerClass?.value)
              }, null, 8, ["field", "class"]))
            : _createCommentVNode("", true)
        ])
      ]),
      appBanner: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(AppBanner, _normalizeProps(_guardReactiveProps(appBannerBindings.value)), null, 16)
        ])
      ]),
      _: 1
    }, 8, ["step"])
  ]))
}
}

})